module.exports = __webpack_public_path__ + "img/infrastructure-20.b53d0153.png";